import { type GetProps, Input, type InputRef } from "antd";
import { useImperativeHandle, useRef } from "react";

export interface VyneReactInputANTDBaseProps extends Omit<GetProps<typeof Input>, "ref"> {
    readonly ref?: React.Ref<HTMLInputElement>;
}

export const VyneReactInputANTDBase = ({ ref, ...props }: VyneReactInputANTDBaseProps) => {
    const inputRef = useRef<InputRef>(null);

    // translate AntD's ref to the whole component to a ref to the actual <input> element
    useImperativeHandle(ref, (): HTMLInputElement => {
        if (inputRef.current) {
            return inputRef.current.input!;
        }

        throw new Error("ANTD Input Not Available");
    }, []);

    return <Input {...props} ref={inputRef} />;
};
